"use client";

import { useSearchParams } from "next/navigation";
import { ChangeEvent, ComponentPropsWithRef, forwardRef, useEffect, useId, useMemo, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import Icon from "@/components/ui/Icon/Icon";
import { PRODUCT_TYPE } from "@/types";

export interface ToggleProps extends ComponentPropsWithRef<"input"> {
  name: string;
  values?: any[];
  label: string;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
}

const ToggleBase = forwardRef<HTMLInputElement, ToggleProps>(({ name, label, field, fieldState, values, ...rest }, ref) => {
  const defaultID = useId();
  const searchParams = useSearchParams();
  const [currentValue, setCurrentValue] = useState<boolean>(rest?.value ? rest.value === "true" : false);
  useEffect(() => {
    if (rest?.value) {
      setCurrentValue(rest.value === "true");
    }
  }, [rest?.value]);
  return (
    <div
      className={`w-fit mx-auto flex items-center ${rest.disabled && searchParams.get("type") !== PRODUCT_TYPE.PROPERTY_TYPE ? "opacity-65 pointer-events-none" : ""}`}
    >
      <label
        className={`text-nowrap transition-all cursor-pointer p-xs rounded-full text-s flex items-center`}
        htmlFor={`${defaultID}-${name}`}
        key={label}
      >
        {label}
        <Icon size="20" className="ml-xs stroke-black" name={`toggle-${currentValue}`} title="toggle" />
      </label>
      <input
        {...rest}
        {...field}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          rest?.onChange?.(event as ChangeEvent<HTMLInputElement>);
          field?.onChange(event);
          setCurrentValue(event.currentTarget.checked);
        }}
        id={`${defaultID}-${name}`}
        ref={field?.ref ?? ref}
        name={name}
        aria-label={label}
        type="checkbox"
        className="hidden"
        checked={currentValue}
      />
    </div>
  );
});
ToggleBase.displayName = "ToggleBase";
export default ToggleBase;
